//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { GeographicalCoordinateInputItem } from './GeographicalCoordinateInputItem';

export class GeographicalRouteInputItem extends ItemBase {
    StartCoordinates: GeographicalCoordinateInputItem | null = null;
    EndCoordinates: GeographicalCoordinateInputItem | null = null;

    constructor(initializer?: Partial<GeographicalRouteInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "GeographicalRouteInputItem";
}
